module.exports = global["Tether"] = require("-!E:\\xampp\\htdocs\\OWL\\electronic\\site_color4\\themes\\electronic\\_dev\\node_modules\\tether\\dist\\js\\tether.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/expose-loader?Tether!./~/tether/dist/js/tether.js
 ** module id = 5
 ** module chunks = 0
 **/